<template>
  <div class="fill-height">
    <FilesUpload
      v-if="step === STEP.IDLE"
      formats=""
      data-test="upload"
      text="Переместите документ(-ы) или нажмите, чтобы выбрать."
      @saveFiles="onSaveFiles"
    />

    <SignatureDocManager
      v-if="showDocManager"
      data-test="preview"
    />
    <SignatureResultPage
      v-if="step === STEP.RESULT"
      data-test="result"
    />
  </div>
</template>

<script>
import FilesUpload from '@/components/FilesUpload'
import SignatureDocManager from '@/components/SignatureDocManager'
import { mapActions, mapState } from 'vuex'
import SignatureResultPage from '@/components/SignatureResultPage'
import { STEP } from '@/helpers/constants'
import { apiResetAllDocuments } from '@/api/api'

export default {
  name: 'SignatureMain',
  components: { SignatureResultPage, FilesUpload, SignatureDocManager },

  data () {
    return {
      STEP
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.changeTab(0)
    })
  },

  async beforeRouteLeave (to, from, next) {
    if (this.step !== STEP.IDLE) {
      this.resetStateByType('signature')
      const reset = await apiResetAllDocuments()
      if (!reset) {
        this.$router.go(0)
      }
    }
    next()
  },

  computed: {
    ...mapState({
      step: state => state.signature.step,
      files: state => state.signature.files
    }),

    showDocManager () {
      return this.step === STEP.UPLOADING || this.step === STEP.PREVIEW
    }
  },

  methods: {
    ...mapActions(['saveInitialFiles', 'changeStep', 'changeTab', 'resetStateByType']),

    onSaveFiles (files) {
      this.saveInitialFiles({ type: 'signature', files })
      this.changeStep({ type: 'signature', step: STEP.UPLOADING })
    }
  }
}
</script>
